<div class="dashboard-widget shadow hover:shadow-md">
  <ng-content></ng-content>
</div>
